import type { DateScheduleConfig } from "@academy-context/primary/shared/trainings/training-schedule-form/shared/training-schedule-form.types";

export enum ATTACHMENT_LABEL {
  DEVIS = "devis",
  PLAQUETTE = "plaquette",
  AUTRE = "autre",
}

export interface Attachment {
  url: string;
  label: ATTACHMENT_LABEL | "";
}

export const ATTACHMENT_LABEL_MAP: Record<ATTACHMENT_LABEL, string> = {
  [ATTACHMENT_LABEL.DEVIS]: "Devis",
  [ATTACHMENT_LABEL.PLAQUETTE]: "Plaquette",
  [ATTACHMENT_LABEL.AUTRE]: "Autre",
};

export const ATTACHMENT_LABEL_OPTIONS = [
  { value: ATTACHMENT_LABEL.DEVIS, label: ATTACHMENT_LABEL_MAP[ATTACHMENT_LABEL.DEVIS] },
  { value: ATTACHMENT_LABEL.PLAQUETTE, label: ATTACHMENT_LABEL_MAP[ATTACHMENT_LABEL.PLAQUETTE] },
  { value: ATTACHMENT_LABEL.AUTRE, label: ATTACHMENT_LABEL_MAP[ATTACHMENT_LABEL.AUTRE] },
] as const;

export interface ProviderInformationBase {
  providerName: string;
  providerContactFirstName: string;
  providerContactLastName: string;
  providerEmail: string;
  providerPhone: string;
}

export interface ProviderInformation extends ProviderInformationBase {
  providerSiret: string;
  providerActivityRegistrationNumber: string;
}

export interface TrainingDetails {
  title: string;
  description: string;
  objective: string;
  price: number | "";
  websiteUrl: string;
  trainingSchedules: DateScheduleConfig[];
  attachments: Attachment[];
}

export interface BaseProviderTrainingFormInputs extends ProviderInformationBase, TrainingDetails {}

export const defaultProviderInformationValues: ProviderInformationBase = {
  providerName: "",
  providerContactFirstName: "",
  providerContactLastName: "",
  providerEmail: "",
  providerPhone: "",
};

export const defaultTrainingDetailsValues: TrainingDetails = {
  title: "",
  description: "",
  objective: "",
  price: "",
  websiteUrl: "",
  trainingSchedules: [],
  attachments: [],
};

export const defaultBaseProviderTrainingValues: BaseProviderTrainingFormInputs = {
  ...defaultProviderInformationValues,
  ...defaultTrainingDetailsValues,
};
